export default __webpack_public_path__ + "static/media/communityimage.0cf62061.svg";